import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter-summary"
export default class extends Controller {
  
  launch(e) {
    const filterKey = e.currentTarget.dataset.key

    // If the filter is q, the search input is not in the dropdown, instead we should find it and focus
    if (filterKey === "q") {
      const searchInput = document.querySelector(".table-query-input")
      searchInput && searchInput.focus()
      return
    }

    // Get the filter dropdown node
    const dropdown = document.getElementById("filter-box")

    // Access the filter dropdown controller
    const controller = this.application.getControllerForElementAndIdentifier(dropdown, "dropdown")

    // Unless we have successfully found the dropdown controller, return
    if (!controller) return

    // Open the dropdown
    controller.toggle()
    
    // Find the form element within the dropdown
    const form = document.querySelector(".filter-form")

    // Attempt to find the named form element as per the filter key
    const formInput = form?.elements[filterKey]

    // Return unless we have successfully found the form element
    if (!formInput) return
    
    // If this element has a Tomselect instance attached, call its focus method
    if (formInput.tomselect) {
      formInput.tomselect.focus()
    
      // Else simply focus on the form element
    } else {
      formInput.focus()
    }
    
  }
  
}
